import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useStyles } from './useStyles';

export const DocumentScoreContainer = ({ className, boundaries, locked, children }) => {
  const styles = useStyles({ boundaries, locked });
  return <div className={cx(styles.root, className)}>{children}</div>;
};

DocumentScoreContainer.propTypes = {
  className: PropTypes.string,
  boundaries: PropTypes.shape({}).isRequired,
  locked: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

DocumentScoreContainer.defaultProps = {
  className: '',
  locked: false,
};
